import { SettingConst } from '@faire/web-api--source/types';

/**
 * Configuration to turn support Retailers in selected countries
 */
export const SUPPORTED_COUNTRIES = 'SUPPORTED_COUNTRIES' as SettingConst<
  'SUPPORTED_COUNTRIES',
  Array<string>,
  'RETAILER' | 'MAKER' | 'ADMIN' | 'VISITOR_WEB'
>;
